<nz-layout class="app-layout">
  <nz-layout>
    <nz-header>
      <app-header></app-header>
    </nz-header>
    <nz-content>
      <div class="main-content"><router-outlet></router-outlet></div>
    </nz-content>
  </nz-layout>
</nz-layout>
